<template>
    <RouterView
        v-if="!isLoadPage"
    />
</template>

<script>

import loader_page from "../loader/LoaderPage.vue";
import {screenSize} from "../../mixins/screenSize";
import {changeBody} from "../../mixins/changeBody";
import {createHelpers} from "vuex-map-fields";
import {getStateMenu} from "../../helpers/menuState";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})
export default {
    name: "couriers_page",
    components: {
        loader_page,
    },
    mixins: [screenSize, changeBody],
    data(){
        return {
            isLoadMenu: true,
        }
    },
    beforeMount() {
        this.$store.dispatch('couriers/ORDERS_POOLING_DELIVERY', {
            actionName: 'ordersPoolingDelivery'
        });
        EventBus.$on('load_menu_main', this.loadMenuMain);
        EventBus.$on('create_new_courier', this.createNewOrder);
    },
    beforeUnmount() {
        EventBus.$off('load_menu_main', this.loadMenuMain);
        EventBus.$off('create_new_courier', this.createNewOrder);
    },
    methods: {
        loadMenuMain() {
            this.isLoadMenu = false;
        },
        createNewOrder() {
            this.$store.dispatch('couriers/CHANGE_STATE_NEW_COURIER', true);
            this.$router.push({ path: '/new/courier/create'});
        }
    },
    computed: {
        ...mUser([
            'isLoadPage',
            'isLoadHeading',
        ]),
        ...mCouriers([
            'activeCourierOrder',
            'couriersOrdersPooling',
            'countAllCouriers'
        ]),
        isLoadPage(){
            return this.isLoadMenu || this.couriersOrdersPooling.loading;
        }
    }
}
</script>
